import './StructureToApplicationSection.scss'

const StructureToApplicationSection = () => (
  <section className="lnn-section lnn-section--alt lnn-structureAppSection">
    <div className="lnn-shell" data-reveal="up">
      <div className="lnn-structureAppSection__head">
        <h2>From Structure to Application</h2>
      </div>

      <div className="lnn-structureAppSection__bridge">
        <div className="lnn-structureAppSection__side lnn-structureAppSection__side--left">
          <p>LeaderBridge applies this structure directly.</p>
          <p>It introduces a way to:</p>

          <ul>
            <li>observe interpretation</li>
            <li>compare intended vs perceived meaning</li>
            <li>surface divergence before execution</li>
            <li>verify alignment before work begins</li>
          </ul>
        </div>

        <div className="lnn-structureAppSection__link" aria-hidden="true" />

        <div className="lnn-structureAppSection__side lnn-structureAppSection__side--right">
          <p>leadership.NET defines the structure.</p>
          <p>LeaderBridge operationalizes it.</p>
        </div>
      </div>
    </div>
  </section>
)

export default StructureToApplicationSection
